import styled, { DefaultTheme } from 'styled-components';

import { Row } from 'antd';

const Styled: any = {};

Styled.Row = styled(Row)<{ theme: DefaultTheme }>`
  .search-btn {
    width: 100%;
    background: rgb(255, 255, 255);
    border-radius: 4px;
    background-color: ${({ theme }) => theme.color.white};
    color: ${({ theme }) => theme.color.tag};
    font-weight: bold;
    box-shadow: 0px 0px 0px 1px rgba(130, 136, 148, 0.16),
      0px 1px 1px -1px rgba(130, 136, 148, 0.48);
  }

  .search-input {
    width: 100%;
    height: 48px;
    background: rgb(255, 255, 255);
    box-shadow: 0px 0px 0px 1px rgba(130, 136, 148, 0.16),
      0px 4px 6px -2px rgba(130, 136, 148, 0.32);
    border-radius: 4px;
    > input {
      background-color: ${({ theme }) => theme.color.white};
    }
  }
  @media (min-width: 600px) {
    .search-input {
      width: 420px;
  }
  .search-btn {
    width: 120px;
  }
`;

export default Styled;
